import { UseQueryOptions } from 'react-query'

import { getStoredToken, isTokenValid } from 'core/actions/helpers/tokenHelpers'
import { peachApi } from 'core/api'
import useGetZendeskConfig from 'core/data/authQueries/useGetZendeskConfig'
import { usePeachQuery } from 'core/system/queries'

interface Params {
  companyId: string
  options?: UseQueryOptions
}

const useGetZendeskToken = ({ companyId, options = {} }: Params) => {
  const [zendeskConfig] = useGetZendeskConfig({ companyId, options })
  const zendeskEnabled = zendeskConfig?.sso?.enabled

  const fetch = () => {
    return peachApi.get({
      url: `/zendesk/sso-token`,
    })
  }

  const token = getStoredToken()
  const tokenIsValid = isTokenValid(token)

  return usePeachQuery({
    queryKey: ['getZendeskToken'],
    queryFn: fetch,
    enabled: zendeskEnabled && tokenIsValid,
    ...options,
  })
}

/** @deprecated Use the auto-generated hooks under core/types or if needed create a new hook under core/types/hooks */
export default useGetZendeskToken
